<template>
  <img
    class="everglance-mark"
    :src="markSrc"
    :width="size"
    :height="height"
    alt=""
    aria-hidden="true"
  />
</template>

<script setup>
import { computed } from 'vue'
import markSrc from '@/assets/images/brand/triangle-mark-open.png'

const props = defineProps({
  size: {
    type: Number,
    default: 80
  }
})

// Source art is roughly square.
const height = computed(() => props.size)
</script>

<style scoped>
.everglance-mark {
  display: block;
  flex-shrink: 0;
  object-fit: contain;
}
</style>
